var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.editingPeriod
    ? _c(
        "div",
        {
          staticClass: "period-editor-container",
          on: {
            click: function($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              return _vm.closeEditor($event)
            }
          }
        },
        [
          _c("div", { staticClass: "period-editor-body" }, [
            _c("div", { staticClass: "period-editor-header" }, [
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.input.title,
                      expression: "input.title"
                    }
                  ],
                  staticClass: "dark",
                  staticStyle: { "font-size": "1.3rem" },
                  attrs: { type: "text", placeholder: "Session Name" },
                  domProps: { value: _vm.input.title },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.input, "title", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticStyle: { margin: "4px 8px" } }, [
                  _vm._v("For Event SDFDFNDF")
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.editingPeriod.unsaved,
                        expression: "!editingPeriod.unsaved"
                      }
                    ],
                    on: {
                      click: function($event) {
                        _vm.removePeriod()
                      }
                    }
                  },
                  [_c("i", { staticClass: "fas fa-trash-alt" })]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        _vm.closeEditor()
                      }
                    }
                  },
                  [_c("i", { staticClass: "fas fa-times" })]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "period-editor-content" }, [
              _c("div", [
                _c("label", [_vm._v("Start")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.input.start,
                        expression: "input.start"
                      }
                    ],
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.input,
                          "start",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.ticks, function(o) {
                    return _c(
                      "option",
                      { key: o[1], domProps: { value: o[0] } },
                      [_vm._v(_vm._s(o[1]))]
                    )
                  })
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c("label", [_vm._v("End")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.input.end,
                        expression: "input.end"
                      }
                    ],
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.input,
                          "end",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.ticks, function(o) {
                    return _c(
                      "option",
                      { key: o[1], domProps: { value: o[0] } },
                      [_vm._v(_vm._s(o[1]))]
                    )
                  })
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c("label", [_vm._v("Room")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.input.room,
                        expression: "input.room"
                      }
                    ],
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.input,
                          "room",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.roomOptions, function(room) {
                    return _c("option", { domProps: { value: room.id } }, [
                      _vm._v(_vm._s(room.name))
                    ])
                  })
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c("label", [_vm._v("Recurrences")]),
                _vm._v(" "),
                _c("div", { staticClass: "group-box" }, [
                  _c(
                    "div",
                    [
                      _vm._l(_vm.recurrences, function(recurrence) {
                        return _c("div", { staticClass: "recur-input" }, [
                          _c("div", [
                            _c("div", { staticClass: "recur-label" }, [
                              _vm._v("Start")
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: recurrence.start,
                                    expression: "recurrence.start"
                                  }
                                ],
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      recurrence,
                                      "start",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  }
                                }
                              },
                              _vm._l(_vm.ticks, function(o) {
                                return _c(
                                  "option",
                                  { key: o[1], domProps: { value: o[0] } },
                                  [_vm._v(_vm._s(o[1]))]
                                )
                              })
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("div", { staticClass: "recur-label" }, [
                              _vm._v("Room")
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: recurrence.room,
                                    expression: "recurrence.room"
                                  }
                                ],
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      recurrence,
                                      "room",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  }
                                }
                              },
                              _vm._l(_vm.roomOptions, function(room) {
                                return _c(
                                  "option",
                                  { domProps: { value: room.id } },
                                  [_vm._v(_vm._s(room.name))]
                                )
                              })
                            )
                          ]),
                          _vm._v(" "),
                          _vm._m(0, true)
                        ])
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "new-recur-input",
                          on: {
                            click: function($event) {
                              _vm.addRecurrence()
                            }
                          }
                        },
                        [
                          _c("div", [_vm._v("Add Recurrence")]),
                          _vm._v(" "),
                          _vm._m(1)
                        ]
                      )
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "recur-preview" })
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "period-editor-footer" }, [
              _c(
                "button",
                {
                  staticClass: "period-edit-save-btn",
                  on: {
                    click: function($event) {
                      _vm.save()
                    }
                  }
                },
                [_vm._v("Save")]
              )
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("i", { staticClass: "fas fa-plus" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("i", { staticClass: "fas fa-plus" })])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75cf371a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75cf371a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/event/periodEditor.vue
// module id = kfxy
// module chunks = 1